import React from 'react';
export const Truth = () => {
  return <section className="text-lg md:text-xl text-gray-800 mb-12 leading-relaxed space-y-6" data-id="element-199" data-mp="4itakih8ivy7">
      <h2 className="font-bold text-2xl md:text-3xl mt-12 mb-6 text-gray-900" data-id="element-200" data-mp="1yabw8hz10z78">
        The Hidden Sleep Mistake Millions Make Every Night
      </h2>

      <p data-id="element-201" data-mp="27a8h08iapdx0">
        Most pillows are designed to support your head.{' '}
        <strong data-id="element-202" data-mp="278dtcmfn37p8">Not your neck.</strong>
      </p>
      <p data-id="element-203" data-mp="2cacx3xfak6mp">
        That sounds minor. But over the course of 7–8 hours, it can make a huge
        difference.
      </p>

      <h3 className="font-bold text-xl md:text-2xl mt-10 mb-4 text-gray-900" data-id="element-204" data-mp="2h7d182skyzb6">
        Introducing Nighttime Neck Collapse™
      </h3>

      <figure className="my-8" data-id="element-205" data-mp="2m1qt3v81aob3">
        <video autoPlay loop muted playsInline className="w-full rounded-sm shadow-sm" data-id="element-206" data-mp="2q1hsuofjgerr">
          <source src="https://cdn.magicpatterns.com/uploads/oEHWd3YPBAx1LqNkF5JPZJ/Section%204%20-%20%20Animation.mp4" type="video/mp4" data-id="element-207" data-mp="2v1vyjzto3cmm" />
        </video>
        <figcaption className="text-sm text-gray-500 mt-3 text-center" data-id="element-208" data-mp="2yws4f6wj7uzl">
          When your neck is unsupported, muscles strain to compensate.
        </figcaption>
      </figure>

      <p data-id="element-209" data-mp="2pvk6ipxxgw61">
        When your pillow fails to support your neck properly, your muscles often
        work throughout the night to compensate.
      </p>
      <p data-id="element-210" data-mp="2kxsgy2kr9m50">
        Hour after hour. Your neck gradually loses support. Your posture shifts.
        Pressure builds. And many people wake up feeling stiff, tight, and
        uncomfortable.
      </p>
      <p data-id="element-211" data-mp="3dmhangjhep6q">
        That's why buying softer pillows... Firmer pillows... Or even expensive
        mattresses... Often fails to solve the real issue.
      </p>
      <p data-id="element-212" data-mp="33tikhu8c6ql0">
        <strong data-id="element-213" data-mp="33ts8xddqgpol">
          Because the problem isn't where your body sleeps. It's how your neck
          is supported while you sleep.
        </strong>
      </p>

      <div className="border-l-4 border-blue-600 p-6 my-8 bg-[#cee0e5]" data-id="element-214" data-mp="dbf9ja9wla4">
        <p className="text-lg font-medium text-gray-900 m-0" data-id="element-215" data-mp="j9tvyc1qhkoq">
          "Most pillows support the head.{' '}
          <a href="#offer" className="text-blue-700 underline font-bold" data-id="element-216" data-mp="o8n55s9zmpj3">
            VelaSleep
          </a>{' '}
          was designed to support both the head and neck."
        </p>
      </div>
    </section>;
};